import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { Subject } from 'rxjs/Subject';
import { ReportsService } from '../reports/reports.service';
import { Response } from '@angular/http';
import { JwtHelper } from 'angular2-jwt';
import { tokenNotExpired } from 'angular2-jwt';
import { EnvironmentsService } from 'app/services/enviornment.service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AuthService {
  private notify = new Subject<any>();
  private currentSession: BehaviorSubject<any>;
  private jwtHelper: JwtHelper = new JwtHelper();
  /**
   * Observable string streams
   */
  notifyObservable$ = this.notify.asObservable();
  constructor(private authHttp: AuthHttp, private envService: EnvironmentsService,
    private reportService: ReportsService) {
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred');
    return Promise.reject(error.message || error);
  }

  public notifyOther(data: any) {
    if (data) {
      this.notify.next(data);
    }
  }

  getUserRoleDetails(): Observable<any> {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let email = currentUser.email;
    return this.authHttp.get(this.envService.config.espApi + "admin/v1/auth/users/"
      + email + "/resourceactions", { withCredentials: true })
      .map((response: Response) => response.json());
  }


  getActions(resourceName: String): void {
    this.getUserRoleDetails()
      .subscribe(actions => {
        this.reportService.resorceactions = actions;
        return this.checkaction(resourceName)
      },
        err => {
          console.log(err)
        });
  }

  checkaction(resourceName): boolean {
    let hideComponent = true;
    this.reportService.resorceactions.forEach(element => {
      switch (element) {
        case 'CRET_NEW_CMS':
          if (resourceName === "CRET_NEW_CMS") {
            hideComponent = false;
          }
          break;
        case 'ADD_NEW_MAXIM_CATG':
          if (resourceName === "ADD_NEW_MAXIM_CATG") { hideComponent = false; }
          break;
        case 'UPDT_PUBL_CMS':
          if (resourceName === "UPDT_PUBL_CMS") { hideComponent = false; }
          break;
        case 'ADD_NEW_MAXIM_ATTR':
          if (resourceName === "ADD_NEW_MAXIM_ATTR") { hideComponent = false; }
          break;
        case 'UPDT_PUBL_MAXIM_ATTR':
          if (resourceName === "UPDT_PUBL_MAXIM_ATTR") { hideComponent = false; }
          break;
        case 'DELT_PUBL_MAXIM_ATTR':
          if (resourceName === "DELT_PUBL_MAXIM_ATTR") { hideComponent = false; }
          break;
        case 'APRO_MAXIM_ATTR':
          if (resourceName === "APRO_MAXIM_ATTR") { hideComponent = false; }
          break;
        case 'IMPR_MAXIM_ATTR':
          if (resourceName === "IMPR_MAXIM_ATTR") { hideComponent = false; }
          break;
        case 'EXPR_MAXIM_ATTR':
          if (resourceName === "EXPR_MAXIM_ATTR") { hideComponent = false; }
          break;
        case 'UPDT_NON_PUBL_MAXIM_ATTR':
          if (resourceName === "UPDT_NON_PUBL_MAXIM_ATTR") { hideComponent = false; }
          break;
        case 'UPDT_PUBL_MAXIM_CATG':
          if (resourceName === "UPDT_PUBL_MAXIM_CATG") { hideComponent = false; }
          break;
        case 'DELT_PUBL_MAXIM_CATG':
          if (resourceName === "DELT_PUBL_MAXIM_CATG") { hideComponent = false; }
          break;
        case 'SHOW_PRODUCTS':
          if (resourceName === "SHOW_PRODUCTS") { hideComponent = false; }
          break;
        default:
      }
    });
    return hideComponent;
  }
  /**
   * JWT code
   */
  decodeTokenStr(token: string): string {
    if (token == "") {
      return null;
    }
    else if (token != null && token != undefined) {
      try {
        let decodedToken: any = this.jwtHelper.decodeToken(token);
        return decodedToken;
      }
      catch (e) {
        return null;
      }

    }
  }

  isTokenNotExpired(): boolean {
    let returnVal;
    try {
      returnVal = tokenNotExpired();
    }
    catch (e) {
      returnVal = false;
    }
    return returnVal;
  }

  //for non-employees
  getToken(authReq: any) {
    return this.authHttp.post(this.envService.config.api + '/v2/auth/token', authReq, { withCredentials: true }).map((response: Response) => response.json());
  }

  getRole(token = undefined): string {
    //fetch authorization data for a given token
    if (!token) {
      token = localStorage.getItem("token");
    }
    if (token != null && token != undefined) {
      try {
        let decodedToken: any = this.jwtHelper.decodeToken(token);
        return decodedToken["rol"];
      }
      catch (e) {
        // Token decode error - invalid token
      }
    }
    return "";

  }


  /**
   * JWT code ENd
   */
}



// WEBPACK FOOTER //
// ./src/app/auth/authservice.service.ts